<script setup lang="ts">
import { ref, watch } from 'vue';
import { useCustomizerStore } from '@/shared/stores/customizer';
import { Icon } from '@iconify/vue';
import Logo from '../logo/Logo.vue';
import LogoIcon from '../logo/LogoIcon.vue';
import RtlLogo from '../logo/RtlLogo.vue';
// dropdown imports
import LanguageDD from '../vertical-header/LanguageDD.vue';
import NotificationDD from '../vertical-header/NotificationDD.vue';
import ProfileDD from '../vertical-header/ProfileDD.vue';
import WhatsAppButton from '@/shared/components/WhatsAppButton.vue';
import SettingsButton from '@/shared/components/SettingsButton.vue';
import Messages from '../vertical-header/Messages.vue';
import RightMobileSidebar from '../vertical-header/RightMobileSidebar.vue';
import { isInboxFeatureEnabled } from '@/features/inbox/config/inboxFeature';

const inboxEnabled = isInboxFeatureEnabled();
const customizer = useCustomizerStore();
const priority = ref(customizer.setHorizontalLayout ? 0 : 0);
watch(priority, (newPriority) => {
    // yes, console.log() is a side effect
    priority.value = newPriority;
});

</script>

<template>
    <v-app-bar elevation="10" :priority="priority" height="64" class="horizontal-header main-head" color="primary">
        <div :class="customizer.boxed ? 'maxWidth v-toolbar__content px-lg-0 px-4' : 'v-toolbar__content px-6'">
            <div class="hidden-sm-and-down logo-container">
            <v-locale-provider v-if="customizer.setRTLLayout" rtl>
                <div class="pt-2 pr-4 d-sm-flex d-none">
                    <RtlLogo />
                </div>
                <div class="pt-2 pr-2 d-sm-none d-flex">
                    <LogoIcon />
                </div>
            </v-locale-provider>
            <v-locale-provider v-else>
                <div class="pt-2 pr-4 d-sm-flex d-none">
                    <Logo />
                </div>
                <div class="pt-2 pr-2 d-sm-none d-flex">
                    <LogoIcon />
                </div>
            </v-locale-provider>
            </div>

           
            <v-btn class="hidden-lg-and-up" icon variant="text" @click.stop="customizer.SET_SIDEBAR_DRAWER" size="small">
                <Icon icon="solar:list-bold" height="22" />
            </v-btn>

            <!-- ------------------------------------------------>
            <!-- Search part -->
            <!-- ------------------------------------------------>

            <!-- Search and Apps menu moved to Start Task button -->

            <!---/Search part -->
            <v-spacer class="hidden-sm-and-down" />
            <!-- ---------------------------------------------- -->
            <!---right part -->
            <!-- ---------------------------------------------- -->

            <!-- ---------------------------------------------- -->
            <!-- translate -->
            <!-- ---------------------------------------------- -->

            <div class="hidden-sm-and-down d-flex align-center">
                <WhatsAppButton />
                <SettingsButton />
                <LanguageDD />
            </div>

            <div class="hidden-md-and-up mt-2">
                <LogoIcon />
            </div>
            <!-- ---------------------------------------------- -->
            <!-- Notification -->
            <!-- ---------------------------------------------- -->

            <!-- ---------------------------------------------- -->
            <!-- Notification -->
            <!-- ---------------------------------------------- -->
            <div v-if="inboxEnabled" class="hidden-sm-and-down">
                <NotificationDD />
            </div>
            <!-- ---------------------------------------------- -->
            <!-- Messages -->
            <!-- ---------------------------------------------- -->
            <div class="hidden-sm-and-down">
                <Messages />
            </div>

            <!-- ---------------------------------------------- -->
            <!-- User Profile -->
            <!-- ---------------------------------------------- -->
            <div class="ms -2 hidden-sm-and-down">
                <ProfileDD />
            </div>

            <!----Mobile ----->
            <v-menu :close-on-content-click="true" class="mobile_popup">
                <template v-slot:activator="{ props }">
                    <v-btn icon class="hidden-md-and-up" color="primary" variant="text" v-bind="props" size="small">
                        <Icon icon="solar:menu-dots-bold-duotone" height="22" />
                    </v-btn>
                </template>
                <v-sheet rounded="lg" elevation="10" class="mt-4 dropdown-box px-4 py-3">
                    <div class="d-flex justify-space-between align-center">
                        <RightMobileSidebar />
                        <SettingsButton />
                        <LanguageDD />
                        <NotificationDD v-if="inboxEnabled" />
                        <Messages />
                        <ProfileDD />
                    </div>
                </v-sheet>
            </v-menu>
        </div>
    </v-app-bar>
</template>

<style scoped>
.logo-container {
    flex-shrink: 0 !important;
    min-width: fit-content;
    overflow: visible !important;
}

.logo-container :deep(.logo) {
    flex-shrink: 0 !important;
    min-width: fit-content;
    overflow: visible !important;
    white-space: nowrap;
}

.logo-container :deep(.logo img) {
    max-width: none !important;
    width: auto !important;
    height: auto;
    display: block;
    object-fit: contain;
}
</style>
